var React = require('react');

function Money (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":"1"},[React.createElement("path",{"fill":"currentColor","d":"M15.733 14.533c-3.026-.786-4-1.6-4-2.866 0-1.454 1.347-2.467 3.6-2.467 2.374 0 3.254 1.133 3.334 2.8h2.946c-.093-2.293-1.493-4.4-4.28-5.08V4h-4v2.88c-2.586.56-4.666 2.24-4.666 4.813 0 3.08 2.546 4.614 6.266 5.507 3.334.8 4 1.973 4 3.213 0 .92-.653 2.387-3.6 2.387-2.746 0-3.826-1.227-3.973-2.8H8.427c.16 2.92 2.346 4.56 4.906 5.107V28h4v-2.867c2.6-.493 4.667-2 4.667-4.733 0-3.787-3.24-5.08-6.267-5.867z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H32V32H0z","key":1})]));
}

Money.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Money;

Money.default = Money;
